import { render } from "./index.vue?vue&type=template&id=d01f145a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d01f145a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01f145a"]])

export default __exports__